export const DEFAULT_FADE_IN = 225;
export const DEFAULT_FADE_OUT = 195;
